import CustomPagination from "../../../shared/components/pagination/CustomPagination";
import { GetStoreGroupsResponse } from "../../../types/app/storeGroupsTypes";
import StoreTypeRow from "./StoreTypeRow";

interface StoreTypeTableProps {
  response: GetStoreGroupsResponse;
  pageNumber: number;
  onPageChange: (event: { selected: number }) => void;
  onEdit: (group: GetStoreGroupsResponse["results"][number]) => void;
  onDelete: (group: GetStoreGroupsResponse["results"][number]) => void;
  deletingGroupId?: number | null;
}

const StoreTypeTable = ({
  response,
  pageNumber,
  onPageChange,
  onEdit,
  onDelete,
  deletingGroupId,
}: StoreTypeTableProps) => {
  return (
    <div className="store-type-table-wrap">
      <table className="store-type-table">
        <thead>
          <tr>
            <th className="checkbox-heading"></th>
            <th>Store type</th>
            <th>Description</th>
            <th>Date added</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {response.results.map((group) => (
            <StoreTypeRow
              key={group.id}
              group={group}
              onEdit={onEdit}
              onDelete={onDelete}
              isDeleting={deletingGroupId === group.id}
            />
          ))}
        </tbody>
      </table>

      <div className="store-type-pagination">
        <CustomPagination
          pageCount={response.totalNumberOfPages || 0}
          forcePage={Math.max(response.pageNumber - 1, 0)}
          currentPageNumber={pageNumber}
          onPageChange={onPageChange}
          pageRangeDisplayed={4}
          renderOnZeroPageCount={null}
        />
      </div>
    </div>
  );
};

export default StoreTypeTable;
